'use strict';

module.exports = function forEach(array, callback) {
	for (var i = 0; i < array.length; i += 1) {
		callback(array[i], i, array); // eslint-disable-line callback-return
	}
};



//////////////////
// WEBPACK FOOTER
// ./~/es-abstract/helpers/forEach.js
// module id = 1103
// module chunks = 1